import { BaseEditor, Editor, Node, NodeEntry, Range, Transforms } from 'slate'
import { Registry } from '@react-registry'
import React from 'react'

import { calculateColSize } from './calculateColSize'
import { deleteTable } from './deleteTable'
import { elementCategories } from '../../elementCategories'
import { useSlate } from 'slate-react'
import { TableDeleteColumnIcon } from '../../../utils/Icon'
import { cellType } from './mergeCells'
import { cloneDeep } from 'lodash'
import { getSpanningCell } from './helper'


const decrementColSpan = (editor: BaseEditor, cellEntry: NodeEntry<Node>, transferSpanToVoidCell = false) => {
  const [cell, path] = cellEntry
  const newAttrs = cloneDeep(cell['attrs'])
  newAttrs.colSpan--
  newAttrs['redactor-attributes'].colspan = newAttrs.colSpan

  if (newAttrs.colSpan === 1) {
    delete newAttrs['redactor-attributes'].colspan
    delete newAttrs.colSpan
  }

  if (transferSpanToVoidCell) {
    newAttrs.void = false
    path[path.length - 1]++
  }

  Transforms.setNodes(editor, {
    attrs: newAttrs
  } as Partial<Node>, {
    at: path
  })
}

export const deleteCol = (event, { editor }) => {
  const tableEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })

  const cellEntry = Editor.above(editor, {
    match: (n) => {
      return cellType.includes(n["type"])
    },
    mode: 'lowest'
  })

  if (!tableEntry || !cellEntry) return

  const colCount = calculateColSize(event, editor)

  if (colCount === 1) {
    deleteTable(event, { editor })
    return
  }

  const colIndex = cellEntry[1].at(-1)

  const cellsInCurrentCol =
    Editor.nodes(editor, {
      at: tableEntry[1],
      match: (n, p) => {
        return cellType.includes(n["type"]) && p.at(-1) === colIndex
      },
      mode: 'lowest'
    })

  const cellsToDecrementColSpanFrom: NodeEntry<Node>[] = []
  const cellsFromWhichSpansNeedToBeTransferred: NodeEntry<Node>[] = []

  for (const [cell, path] of cellsInCurrentCol) {
    let { colSpan } = cell?.['attrs'] ?? {}


    if (colSpan && colSpan > 1) {
      cellsFromWhichSpansNeedToBeTransferred.push([cell, path])
    }

    if (Editor.isVoid(editor, cell)) {

      const spanningCellEntry = getSpanningCell(editor, path)

      if (spanningCellEntry) {
        const [, spanningCellPath] = spanningCellEntry

        if (spanningCellPath.at(-2) === path.at(-2)) {
          cellsToDecrementColSpanFrom.push(spanningCellEntry)
        }
      }
    }
  }

  for (const ne of cellsToDecrementColSpanFrom) {
    decrementColSpan(editor, ne)
  }

  for (const ne of cellsFromWhichSpansNeedToBeTransferred) {
    decrementColSpan(editor, ne, true)
  }

  Transforms.removeNodes(editor, {
    at: tableEntry[1],
    match: (n, p) => {
      return cellType.includes(n["type"]) && p.at(-1) === colIndex
    }
  })

  let colWidths = tableEntry[0]["attrs"].colWidths.slice()
  colWidths.splice(colIndex, 1)
  Transforms.setNodes(
    editor,
    {
      attrs: {
        ...tableEntry[0]["attrs"],
        colWidths,
        cols: colCount - 1
      }
    } as Partial<Node>,
    { at: tableEntry[1] }
  )


}
const DeleteColButton = (props) => {
  const editor = useSlate()
  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: deleteCol,
        isDisable: { func: deleteColButtonDisabler, params: { editor } },
        additionalParams: { editor }
      })}
    </React.Fragment>
  )
}
const deleteColButtonDisabler = ({ editor }) => {
  if (editor.selection && Range.isExpanded(editor.selection)) return true

  const [table] = Editor.nodes(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })
  return !table
}
Registry.register(
  {
    iconName: <TableDeleteColumnIcon />,
    IngressComponent: DeleteColButton,
    category: elementCategories.TABLE_ACTION,
    toolbar: {
      inSlashToolbar: false,
    },
    canCustomize: false,
    title: 'Delete column',
    isContentStackElement: true
  },
  {
    id: 'table-create-header',
    registry: 'v2.element'
  }
)
